<template>
    <div>
        <el-form ref="form1" class="form1" :model="formItem" :rules="form1Rules" label-width="200px">
            <h3 class="title-group">1、选择调用计划</h3>
            <el-form-item prop="account_id" label="选择账户：" class="label-required">
                <ESelect v-model="formItem.account_id" filterable remote
                           placeholder="请选择要调用计划的账户，支持名称或用户名关键字搜索账户"
                           :remote-method="getAccountList"
                           :loading="accountLoading"
                           popper-class="select-option-long-text-wrap"
                           @change="changeAccount"
                           clearable
                           style="width: 400px;">
                    <el-option
                        v-for="item in accountList"
                        :key="item.account_id"
                        :label="item.account_name+'-'+item.account_id"
                        :value="item.account_id">
                        {{item.account_name}}({{item.account_id}})
                    </el-option>
                </ESelect>
            </el-form-item>
            <el-form-item prop="extension_type" label="选择计划：" class="label-required">
                <el-radio-group :value="formItem.extension_type" @change="handleRadioGroup">
                    <el-radio :label="'2'">应用</el-radio>
                    <el-radio :label="'3'">快应用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="plan_id" label="" class="label-required">
                <div style="display: flex;">
                    <JtSelect :value="formItem.plan_id" filterable
                               placeholder="请选择要调用的计划，支持名称或ID关键字搜索计划"
                               @change="changePlan"
                               clearable
                               multiple
                               popper-class="select-option-long-text-wrap"
                               style="width: 400px;"
                              :filter-method="SearchFilter"
                               @visible-change="handleVisible"
                               ref="planJtSelect"
                    >
                        <div :style="{cursor: 'pointer', paddingLeft: '20px', marginBottom: '6px', color: '#409EFF'}">
                            <span :style="{display: 'inline-block'}"  @click="handleAllSelect('all')">全选</span>
                            <span :style="{display: 'inline-block', marginLeft: '10px'}" @click="handleAllSelect('cancel')">取消全选</span>
                        </div>
                        <el-option
                            v-for="item in planList"
                            :key="item.plan_id"
                            :label="item.plan_name+'('+item.plan_id+')'"
                            :value="item.plan_id">
                            {{item.plan_name}}（{{item.plan_id}}）
                        </el-option>
                    </JtSelect>
                    <DelayButton :delay="120" :loading="updatePlanLoading" :disabled="!formItem.account_id" :click-fn="updatePlanList" text="更新计划" class="ml20"/>
                    <span class="text-color-gray ml20">请勿频繁点击，以免造成接口调用次数超限</span>
                </div>
                <p class="text-color-gray mt10 font12px">符合以下条件的计划目前不可选：</p>
                <p class="text-color-gray ml6 font12px">
                    1、推广流量非信息流、非联盟；2、计划下存在广告组/广告为空；3、计划下包含或只有无素材的无图广告；4、包含组图；5、计划/广告组/广告名称超过80字； 6、包含多个产品；7、开启或设置了一键起量/衍生视频（目前接口不支持）；
                </p>
            </el-form-item>
            <el-form-item prop="is_check_plan">
                <el-button v-if="!isCheckedPlanInfo" :disabled="!formItem.account_id||!formItem.plan_id" :loading="checkPlanLoading" @click="checkPlanInfo" style="width: 120px;" type="primary" size="mini" ghost >核实计划信息</el-button>
                <el-button v-else type="primary" size="mini" style="width: 120px;">已核实</el-button>
            </el-form-item>


            <h3 class="title-group">2、选择目标账户</h3>
            <el-form-item prop="target_account" label="目标账户：" class="label-required">
                <el-tooltip :disabled="!hasGroupTargetId" content="包含定向包的计划模板暂不支持跨账户创建">
                    <ESelect ref="targetAccountSelect"
                               :value="formItem.target_account"
                               filterable
                               remote
                               value-key="account_id"
                               multiple
                               placeholder="请选择目标账户"
                               @change="changeTargetAccount"
                               :disabled="hasGroupTargetId||!isCheckedPlanInfo"
                               :remote-method="getTargetAccountList"
                               :loading="targetAccountLoading"
                               style="width: 400px;">
                        <el-option
                            v-for="item in targetAccountList"
                            :key="item.account_id"
                            :disabled="item.disabled"
                            :label="item.account_name+'-'+item.account_id"
                            :value="item.account_id">
                            {{item.account_name}}({{item.account_id}})
                        </el-option>
                    </ESelect>
                </el-tooltip>


                <div class="text-color-gray mt10 font12px">
                    <p>批量创建的计划创建在选择的所有目标账户内，内容完全一致。有以下两点需要注意：</p>
                    <p class="ml6">1、无法跨账户使用的内容请勿选择，比如人群包。</p>
                    <p class="ml6">2、跨账户创建请确保账户内权限一致，否则会创建失败。</p>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {JtSelect} from "@/components/Ele";
    import DelayButton from "@/views/marketingManagement/oppo/components/delayButton.vue";
    import API from "@/api/marketManage/oppoBatch";
    import utils from "@/libs/utils";
    import Tips from './tips.vue'
    import {planModal, errorPlanModal, errorModal} from '../modal/index.js'
    import CheckPlanModal from "@/views/marketingManagement/oppo/modal/checkPlanModal.vue";
    import {uniq, uniqBy} from 'lodash'
    export default {
        name: 'oppo_stepsPlan',
        components: {CheckPlanModal, DelayButton, JtSelect, Tips},
        data() {
            const validatePlan = (rule, value, callback) => {
                if (!this.isCheckedPlanInfo) {
                    callback(new Error('请核实计划信息'));
                } else {
                    callback();
                }
            };
            return {
                isCheckedPlanInfo:false,
                accountLoading: false,
                checkPlanLoading: false,
                updatePlanLoading: false,
                targetAccountLoading: false,
                hasGroupTargetId:false,
                accountList: [],
                planList: [],
                options: [], //计划列表缓存
                targetAccountList: [],
                cacheTargetAccountList: [], //缓存所有目标账户
                formItem:{
                    account_id:'',
                    extension_type: '2', // 选择计划
                    plan_id:[],
                    target_account:[],
                    task_id: '',
                },
                form1Rules:{
                    account_id:[
                        { required: true, message: '请选择账户', trigger: 'change' }
                    ],
                    plan_id:[
                        { required: true, message: '请选择计划', trigger: 'change'},
                    ],
                    is_check_plan:[
                        { validator: validatePlan },
                    ],
                    target_account:[
                        { type: 'array', required: true, message: '请选择目标账户', trigger: 'change' }
                    ],
                },
                check: false, //是否全部验证通过  true 通过  false 未通过
                account_balance_list: [], //账户余额提示数组
                checkMax: 50
            }
        },
        methods:{
            //校验用方法 验证表单 提供给外面验证
            async validateSteps() {
                await this.$refs.form1.validate();
                return await this.confirmCheckBudget()
            },
            changeAccount(val){
                // if(this.uploadStore.length>0){
                //     this.resetStep2Data();
                //     this.resetStep3Data();
                // }
                if(!val){
                    this.planList = [];
                    this.options = []
                    this.formItem.plan_id = [];
                    this.isCheckedPlanInfo = false;
                    return false;
                }
                this.formItem.plan_id = [];
                this.isCheckedPlanInfo = false;
                this.formItem.target_account = [];
                this.getPlanList();
            },
            handleRadioGroup(value) {

                if(this.formItem.account_id == '') {
                    this.formItem.extension_type = value === '2' ? '3' : '2'
                    return;
                }
                if(this.formItem.plan_id.length === 0) {
                    this.formItem.extension_type = value === '2' ? '3' : '2'

                    this.formItem.plan_id = [];
                    this.isCheckedPlanInfo = false;
                    this.planList = [];
                    this.options = []
                    this.formItem.target_account = [];
                    this.getPlanList();
                    return
                }
                this.$confirm('计划类型修改后内容会清空，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.formItem.extension_type = value === '2' ? '3' : '2'

                    this.formItem.plan_id = [];
                    this.isCheckedPlanInfo = false;
                    this.planList = [];
                    this.options = []
                    this.formItem.target_account = [];
                    this.getPlanList();
                }).catch(() => {
                    this.formItem.extension_type = value === '2' ? '2' : '3'
                });

            },
            getPlanList(){
                if(!this.formItem.account_id) return this.planList = [];
                API.getPlanList({
                    account_id:this.formItem.account_id,
                    extension_type: this.formItem.extension_type
                }).then(res=>{
                    this.planList = (res.data||[]).map(item=>({res_label:`${item.plan_name}${item.plan_id}'`, ...item}));
                    this.options = (res.data||[]).map(item=>({res_label:`${item.plan_name}${item.plan_id}'`, ...item}));
                },err=>{
                    this.planList = [];
                    this.options = []
                })
            },

            updatePlanList(){
                if(!this.formItem.account_id) return this.$message.error('请先选择账户');
                this.planNotifyTip = this.$notify.success({
                    title: '正在更新',
                    message: '请求成功，请稍候…',
                    duration: 0
                });
                this.updatePlanLoading = true;
                API.updatePlanList({
                    account_id:this.formItem.account_id,
                },{
                    timeout: 120*1000,
                }).then(res=>{
                    console.log('updatePlanList',res);
                    if(this.planNotifyTip){
                        this.planNotifyTip.close();
                        this.planNotifyTip = null;
                    }
                    this.updatePlanLoading = false;
                    this.getPlanList();
                    this.$notify.success({
                        title: '更新成功',
                        message: '计划列表更新成功',
                        duration: 1000*3
                    });
                },err=>{
                    if(this.planNotifyTip){
                        this.planNotifyTip.close();
                        this.planNotifyTip = null;
                    }

                    this.updatePlanLoading = false;
                    console.log('updatePlanList err',err);
                    this.$notify.error({
                        title: '更新失败',
                        message: err.info,
                        duration: 0
                    });
                })
            },
            checkPlanInfo(){
                this.getPlanDetailInfo()
                // this.checkPlanLoading = true;
                // this.$refs.checkPlanModal.checkPlanInfo();

            },
            getPlanDetailInfo() {
                this.checkPlanLoading = true
                API.postPlanDetailInfo({
                    account_id:this.formItem.account_id,
                    plan_id:this.formItem.plan_id,
                }).then(res=>{
                    // this.dataLoading = false;
                    let resData = res.data||{};
                    //
                    // this.actionPlanInfo.ad_info = resData.ad_info||[];
                    // this.actionPlanInfo.group_info = resData.group_info||[];
                    // this.actionPlanInfo.plan_info = resData.plan_info||{};
                    // this.actionPlanInfo.task_id = resData.task_id;
                    // this.actionPlanInfo.map = resData.map;
                    // this.actionPlanInfo.target_info = resData.target_info||[];
                    //
                    let hasGroupTargetId = resData.list.some(item=>item.group_info.some(itemchild=>itemchild.targetId))
                    this.hasGroupTargetId = hasGroupTargetId

                    if(hasGroupTargetId) {
                        this.formItem.target_account = []
                    }

                    this.formItem.task_id = res.data.task_id
                    // this.formItem.extension_type = res.data.list[0].plan_info.extensionType.toString()
                    this.checkPlanLoading = false
                    const {vm} = planModal({
                        props:{
                           propsData: res.data||{}
                        },
                        cbs:{
                            confirm:() => {
                                this.isCheckedPlanInfo = true
                                this.confirmPlanInfo()
                                vm.close()
                            }
                        }
                    });

                },err=>{
                    console.log('getPlanDetailInfo err',err);
                    // this.dataLoading = false;
                    // this.$message.error(err.info||'操作失败');
                    // this.handleClose();
                    // this.$emit('update');

                    this.checkPlanLoading = false
                    if(err.code == 10000) {
                        const {vm} = errorPlanModal({
                            props:{
                                title: err.info,
                                list: err.data
                            },
                            cbs:{
                                confirm:() => {
                                    let select_plan_options = err.data
                                    if(select_plan_options.length !== 0) {
                                        select_plan_options.forEach((item)=>{
                                            let msg = item.err_msg.length !== 0 ? item.err_msg.join('<br/>') : '暂无错误信息';
                                            this.$refs.planJtSelect.setTagState(item.id.toString(), [Tips,{ msg:`<div>${msg}</div>` }])
                                        })
                                    }
                                    vm.close()
                                }
                            }
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                })
            },
            confirmPlanInfo(data){
                // this.isCheckedPlanInfo = true;
                // this.hasGroupTargetId = data.hasGroupTargetId;
                // this.taskId = data.taskId;
                // this.sourceAppId = data.appId;
                /* 核实信息后，目标账户设置默认值 */
                let curAccount = this.accountList.find(item=>item.account_id==this.formItem.account_id);
                if(curAccount){
                    if(this.formItem.extension_type == 3) {
                        if(this.hasGroupTargetId) {
                            this.$nextTick(()=>{
                                this.targetAccountList = [curAccount]
                                this.formItem.target_account = [this.formItem.account_id]
                            });
                        }else{
                            if(this.formItem.target_account.length === 0) {
                                this.$nextTick(()=>{
                                    this.targetAccountList = [curAccount]
                                    this.formItem.target_account = [this.formItem.account_id]
                                });
                            }
                        }
                    }else{
                        this.$nextTick(()=>{
                            this.targetAccountList = uniqBy([utils.deepClone(curAccount), ...this.targetAccountList], 'account_id') ;
                            this.formItem.target_account = uniq([this.formItem.account_id, ...this.formItem.target_account]);
                        });
                    }

                }
                this.$refs.form1.validate('is_check_plan');
            },
            getAccountList(query){
                if(!query) return this.accountList = [];
                this.accountLoading = true;
                API.getAccountList({
                    search:query,
                }).then(res=>{
                    let resList = res.data||[];
                    /* 数据量大时直接截取前100条 */
                    this.accountList = resList.slice(0,100);
                    this.accountLoading = false;
                },err=>{
                    console.log('getAccountList err',err);
                    this.accountList = [];
                    this.accountLoading = false;
                })
            },
            changeTargetAccount(val){
                let res_target = []

                let maxLen = val && val.length
                if(maxLen > this.checkMax) {
                    return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                }
                if(this.formItem.extension_type == 3) {
                    if(val && val.length != 0) {
                        res_target = val.length > 1 ? val[val.length - 1] : val[0]


                        if(this.formItem.target_account && this.formItem.target_account.length >= 1) {
                            this.$confirm('快应用只可选一个目标账户，确认要修改吗？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {


                                this.$message({
                                    type: 'success',
                                    message: '成功!'
                                });
                                this.$refs.targetAccountSelect.blur()
                                this.formItem.target_account = [res_target]
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                                this.$refs.targetAccountSelect.blur()
                                // this.formItem.target_account = []
                            });
                        }else{
                            this.formItem.target_account = val
                        }
                    }else {
                        this.formItem.target_account = val
                    }
                }else{
                    this.formItem.target_account = val
                }
                // this.resetStep2Data();
            },
            getTargetAccountList(query){
                if(!query) return

                // this.accountList = [];

                this.targetAccountLoading = true;
                API.getAccountList({
                    search:query,
                }).then(res=>{
                    let resList = res.data||[];
                    /* 数据量大时直接截取前100条 */
                    this.targetAccountList = resList.slice(0,100);
                    this.cacheTargetAccountList = resList
                    this.targetAccountLoading = false;
                },err=>{
                    console.log('getAccountList err',err);
                    this.targetAccountList = [];
                    this.cacheTargetAccountList = []
                    this.targetAccountLoading = false;
                })
            },
            showNextSelectSizeModal(list,cb) {
                if (!list.length) {
                    cb && cb()
                    return
                }
                const data = list.shift();
                if (data) {
                    this.showSelectSizeModal(data, ()=> {
                        this.showNextSelectSizeModal(list, cb)
                    })
                }
            },
            showSelectSizeModal(data, cb) {
                const onSubmit = (data)=> {
                    vm.close()
                }
                const { vm } = errorModal({
                    props: {
                        params: data,
                    },
                    on: {
                        closed: ()=> {
                            cb&& cb()
                        }
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            confirmCheckBudget(){
                return new Promise((resolve, reject)=>{
                    /* 判断预算逻辑 */
                    this.nextStepLoading = true;
                    API.checkBudget({
                        task_id:this.formItem.task_id,
                        target_account:this.formItem.target_account.join(',')
                    }).then(res=>{
                        // console.log('checkBudget',res);
                        // this.nextStepLoading = false;
                        resolve(this.formItem)
                        // 处理温馨提示 弹出
                    },err=>{
                        console.log('checkBudget err',err);
                        this.nextStepLoading = false;
                        let errData = err.data||{};
                        this.account_balance_list = errData.account_balance_list||[];
                        let budgetData = errData.budget||[];
                        let adGroupCreateNum = errData.adgroup_create_num||[];
                        let planCreateNum = errData.plan_create_num||[];


                        this.showNextSelectSizeModal(this.account_balance_list,()=>{
                            if(adGroupCreateNum.length>0){
                                let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有广告组数量 <span class="text-color-error">超过490条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                                adGroupCreateNum.forEach(item=>{
                                    htmlStr += `<p class="font12px">${item.name}</p>`;
                                });
                                htmlStr += `</div>`;
                                this.$confirm(htmlStr,'提示',{
                                    confirmButtonText: '可继续创建',
                                    cancelButtonText: '取消创建',
                                    type: 'warning',
                                    dangerouslyUseHTMLString: true,
                                    customClass:'wide-confirm-box-550 wide-confirm-box-15vh',
                                }).then(()=>{
                                    console.log('继续');
                                    if(planCreateNum.length>0){
                                        let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有计划数量 <span class="text-color-error">超过40条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                                        planCreateNum.forEach(item=>{
                                            htmlStr += `<p class="font12px">${item.name}</p>`;
                                        });
                                        htmlStr += `</div>`;
                                        this.$confirm(htmlStr,'提示',{
                                            confirmButtonText: '可继续创建',
                                            cancelButtonText: '取消创建',
                                            type: 'warning',
                                            dangerouslyUseHTMLString: true,
                                            customClass:'wide-confirm-box-550 wide-confirm-box-15vh',
                                        }).then(()=>{
                                            resolve(this.formItem)
                                        }).catch(()=>{
                                            reject();
                                        })
                                    }else{
                                        resolve(this.formItem);
                                    }
                                }).catch(()=>{
                                    console.log('取消');
                                    reject();
                                })
                            }else{
                                if(planCreateNum.length>0){
                                    let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有计划数量 <span class="text-color-error">超过40条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                                    planCreateNum.forEach(item=>{
                                        htmlStr += `<p class="font12px">${item.name}</p>`;
                                    });
                                    htmlStr += `</div>`;
                                    this.$confirm(htmlStr,'提示',{
                                        confirmButtonText: '可继续创建',
                                        cancelButtonText: '取消创建',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550 wide-confirm-box-15vh',
                                    }).then(()=>{
                                        resolve(this.formItem)
                                    }).catch(()=>{
                                        reject();
                                    })
                                }else{
                                    resolve(this.formItem);
                                }
                            }
                        })
                        // return reject(err);


                    });
                })
            },
            // 全选操作相关逻辑
            handleVisible(value) {
                if(!value) {
                    this.planList = []
                    this.planList = this.options
                }
            },
            SearchFilter(val) {
                this.planList = this.options.filter(item=> {
                        return item.res_label.toLowerCase().indexOf(val.toLowerCase()) > -1
                    }
                )
            },
            handleAllSelect(type) {
                if(type == 'all') {
                    let append = this.planList.map(item=>item.plan_id)
                    let cur_list = uniq([...this.formItem.plan_id, ...append])
                    let maxLen = cur_list.length
                    if(maxLen > this.checkMax) {
                        return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                    }
                    this.formItem.plan_id =  uniq([...this.formItem.plan_id, ...append])
                }else{
                    let optionList_ids = this.planList.map(item=>item.plan_id)
                    let channel_ids = this.formItem.plan_id.filter(item=> !optionList_ids.includes(item))
                    this.formItem.plan_id = [...channel_ids]
                }
                this.isCheckedPlanInfo = false;
                this.$refs['planJtSelect'].blur()
            },
            changePlan(value){
                this.isCheckedPlanInfo = false;

                let maxLen = value && value.length
                if(maxLen > this.checkMax) {
                    return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                }
                this.formItem.plan_id = value

            },
        }
    }
</script>
<style>
.wide-confirm-box-15vh{
    vertical-align: top !important;
    margin-top: 15vh;
}
</style>
